export enum DigitalMediaType {
    Unknown = 1,
    Image = 2,
    Video = 3,
    Audio = 4,
    Document = 5
}